module.exports = __webpack_public_path__ + "static/2-4385fb0f46e470e33d0b62e7ce6d16ab.jpg";